import React from 'react';
import { Box, FormControl, FormHelperText, IconButton, InputAdornment, OutlinedInput, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import { isValidAmount } from '../helpers';
import { FlagsDropdown } from './FlagsDropdown';
import { StyledCauseAmountInput } from './StyledComponents/CauseAmountInputStyles';

export function CauseAmountInput({
	selectedCurrencyOption,
	currencyChangeHandler,
	disableCurrencyEdit = false,
	className,
	mode,
	quantity,
	onIncrement,
	onDecrement,
	unitRate,
	currencyCode,
	productName,
	amountProps,
	currencySymbol,
}) {
	const validateDonationAmount = (event) => {
		if (!isValidAmount(event.key)) {
			event.preventDefault();
		}
	};

	const total = mode === 'stepper' ? quantity * unitRate : 0;

	return (
		<StyledCauseAmountInput sx={{ width: '100%' }}>
			<Box className="AmountSectionWrapper">
				<Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center" className={mode === 'stepper' ? 'StepperModeRow' : 'AmountModeRow'}>
					<FlagsDropdown
						className={className}
						selectedOption={selectedCurrencyOption}
						onChange={currencyChangeHandler}
						disableEdit={disableCurrencyEdit}
					/>

					{mode === 'stepper' ? (
						<Box className="QuantityStepperBox">
							<IconButton size="small" onClick={onDecrement} disabled={quantity <= 1}>
								<RemoveIcon fontSize="inherit" />
							</IconButton>
							<Typography className="QuantityValue">{quantity}</Typography>
							<IconButton size="small" onClick={onIncrement}>
								<AddIcon fontSize="inherit" />
							</IconButton>
						</Box>
					) : (
						<FormControl variant="outlined" error={!!amountProps?.error} sx={{ flex: 1 }}>
							<OutlinedInput
								{...amountProps}
								onKeyPress={validateDonationAmount}
								size="small"
								onWheel={(e) => e.target.blur()}
								startAdornment={
									<InputAdornment
										position="start"
										sx={{ '& p': { fontWeight: '700 !important', fontSize: '20px !important', color: '#333333 !important' } }}
									>
										{currencySymbol}
									</InputAdornment>
								}
								endAdornment={
									<InputAdornment
										position="end"
										sx={{
											marginLeft: '5px',
											'& p': { marginTop: '0 !important', fontWeight: '700 !important', fontSize: '20px !important', color: '#333333 !important' },
										}}
									>
										.00
									</InputAdornment>
								}
							/>
							<FormHelperText>{amountProps?.helpertext}</FormHelperText>
						</FormControl>
					)}
				</Stack>

				{mode === 'stepper' && (
					<Box className="FundraisingGoalBox">
						<Box>
							<Typography className="GoalLabel">Your Fundraising Goal</Typography>
							<Typography className="GoalSubLabel">
								{productName} × {quantity}
							</Typography>
						</Box>
						<Typography className="GoalTotal">
							{currencyCode} {total.toLocaleString()}
						</Typography>
					</Box>
				)}
			</Box>
		</StyledCauseAmountInput>
	);
}
